module.exports = __webpack_public_path__ + "static/media/bao-tri.b5ea9553.png";